import React from 'react';
import { CircularProgress, DialogContent } from '@material-ui/core';
import * as lib from '~/dependencies';
import { SelectedIcon, NoSelectedIcon } from '~/assets/svgIcons';
import messagesToast from '~/validations/messagesNotifications';
import * as locales from '~/i18n/locales';
import { BoxLanguages, ListLanguages, Dialog } from './styles';

export default function Idioms({ languageName, handleChangeLng, loading }) {
  // HOOKS
  const { t } = lib.useTranslation();

  // CONSTS
  const availableLngs = Object.values(locales).filter(
    e => e.languageName !== languageName
  );

  function changeLanguage(lng, langName) {
    if (lng) {
      handleChangeLng(lng, langName);
      lib.ToastMessage('success', messagesToast().SETTINGS.language.success);
    }
  }

  return (
    <BoxLanguages>
      <h3 data-test-id="language-title">
        {t('screens.configuration.components.idioms')}
      </h3>
      <Dialog open={loading} aria-labelledby="draggable-dialog-title">
        <DialogContent>
          <CircularProgress className="loading" />
        </DialogContent>
      </Dialog>
      <ListLanguages>
        <div className="row" role="presentation">
          <div>
            <span>{languageName}</span>
          </div>
          <lib.ReactSVG src={SelectedIcon} className="icon" />
        </div>
        {availableLngs.map(e => (
          <div
            key={e.lang}
            className="row"
            onClick={() => changeLanguage(e.lang, e.languageName)}
            role="presentation">
            <div>
              <span>{e.languageName}</span>
            </div>
            {e.lang === languageName ? (
              <lib.ReactSVG src={SelectedIcon} className="icon" />
            ) : (
              <lib.ReactSVG src={NoSelectedIcon} className="icon" />
            )}
          </div>
        ))}
      </ListLanguages>
    </BoxLanguages>
  );
}

Idioms.defaultProps = {
  languageName: 'English',
  handleChangeLng: () => {},
  loading: false,
};

Idioms.propTypes = {
  languageName: lib.PropTypes.string,
  handleChangeLng: lib.PropTypes.func,
  loading: lib.PropTypes.bool,
};
